import type { TFunction } from 'i18next';
import { LocationSegmentType } from '../../../constants';

export const getBulkPlaceholders = (t: TFunction) => ({
  [LocationSegmentType.DMA]: t(
    'Locations may be entered as either semicolon, or new line separated values.\n\n Examples:\n\n New York\n Glendive'
  ),
  [LocationSegmentType.Zip]: t(
    'Locations may be entered as either semicolon, or new line separated values.\n\n Examples:\n\n 94501\n 91101'
  ),
});
